import {cookie} from '../utils/commonFn';
// apiUrl
const apiUrl = '//activity.gyyx.cn/wendaoshop/';
//获取商品出售详情页
export const getDetailUrl = apiUrl + 'sku/getdetail?skuCode=1';
//获取商品出售详情页
export const getDetailUrl2 = apiUrl + 'sku/getdetail?skuCode=2';
//加入购物车
export const addshopcartUrl = apiUrl + 'order/addshopcart';

//查看我的订单列表
export const loadmyorderinfoUrl = apiUrl + 'order/loadmyorderinfo';

//获取订单中某一条的收货地址
export const loadaddressinfoUrl = apiUrl + 'order/loadaddressinfo';
// 获取游戏礼包列表数据接口
export const loadmygamegiftUrl = apiUrl + 'order/loadmygamegift';
//领取游戏礼包接口
export const receivegamegiftUrl = apiUrl + 'order/receivegamegift';
// 修改我的订单地址
export const editorderaddressUrl = apiUrl + 'order/editorderaddress';
//查看我的购物车总数
export const loadshopcarttotalcountUrl = apiUrl +'order/init';
//更新我的订单收货地址
export const updateorderaddressUrl = apiUrl +'order/editorderaddress';
//查看订单物流接口
export const loadorderlogisticlistUrl = apiUrl +'order/loadorderlogisticlist';
//取消订单接口
export const cancelorderUrl = apiUrl + 'order/cancelorder';
// 加载兑换奖励下拉列表接口
export const loadexchangerewardlistUrl= apiUrl + 'order/loadexchangerewardlist';
// 兑换游戏礼包接口
export const exchangegamegiftUrl= apiUrl + 'order/exchangegamegift';
export const loadmyexchangelistUrl= apiUrl + 'order/loadmyexchangelist';
//退出接口
export const loginOutUrl = '//accountv5.gyyx.cn/v1/account/loginOut';
//二十周年礼盒商品详情
export const getProductDetailsUrl = apiUrl + 'sku/getdetail';

//订单支付状态
export const order_status = (status) => {
    switch (status) {
        case 'WaitPayment':
            return "未支付";
        case 'Cancel':
            return "已撤消";
        case 'Close':
            return "未付款，已关闭";
        case 'WaitDelivery':
            return '已付款，待发货';
        case 'Delivering':
            return '发货中';
        case 'Delivered':
            return '已发货';
        case 'Completed':
            return '已完成';
        case 'Error':
            return '订单异常';
        default:
            break;
    }

}

export const theActionPageType = cookie.get("GyyxLoginType") === "wegame"?"wegame":"stage";

//抽奖图片
export const prizeImgs = {img1:"prize1.png",img2:"../images/prize2.png",img3:"../images/prize3.png",img4:"../images/prize4.png",
                          img5:"../images/prize5.png",img6:"../images/prize6.png",img7:"../images/prize7.png",img8:"../images/prize8.png",
                          img9:"../images/prize9.png",img10:"../images/prize10.png",img11:"../images/prize11.png"}
// 获取我的奖品列表数据
export const getMyprozeListUrl= apiUrl + 'prize/getMyPrizeList';
// 加载top奖品滚动列表接口
export const loadTopPrizeListUrl= apiUrl + 'prize/loadTopPrizeList';
// 抽奖接口
export const lotteryUrl= apiUrl + 'prize/lottery';
// 初始化抽奖状态
export const initLotteryUrl= apiUrl + 'prize/initUserPrizeInfo';
// 获取我的奖品配送地址
export const getMyPrizeAddressUrl= apiUrl + 'prize/getMyPrizeAddress';
// 编辑我的奖品配送地址
export const editMyPrizeAddressUrl= apiUrl + 'prize/editMyPrizeAddress';
// 兑换卡查询
export const getcardlist= apiUrl + 'order/getcardlist';
// 页面黑白页控制
export const blackPageUrl= '//apicloud.gyyx.cn/www/config/black';